<script lang="ts">
  /**
   * MobileEventRow - one event of a phone Calendar list (Month's selected day,
   * Agenda): type-coloured bar, title, grey meta line. ≥56px; a tap opens the
   * event sheet. Contract: plans/mobile-v2.md §3.6 (Calendar).
   */
  import type { CalendarEvent } from '../../lib/types';
  import { eventColor } from '../../lib/eventColors';
  import { eventMetaLine } from '../../lib/mobileCalendar';

  interface Props {
    event: CalendarEvent;
    onSelect: (event: CalendarEvent) => void;
  }

  let { event, onSelect }: Props = $props();
</script>

<button type="button" class="row" onclick={() => onSelect(event)}>
  <span class="bar" style:background={eventColor(event.type)} aria-hidden="true"></span>
  <span class="text">
    <span class="title">{event.title}</span>
    <span class="meta">{eventMetaLine(event)}</span>
  </span>
</button>

<style>
  .row {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    min-height: 56px;
    padding: 8px 16px;
    text-align: left;
    font: inherit;
    color: #111827;
    background: #fff;
    border: 0;
    border-top: 1px solid #f1f5f9;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }

  .row:active {
    background: #f9fafb;
  }

  .bar {
    align-self: stretch;
    flex: none;
    width: 4px;
    min-height: 36px;
    border-radius: 2px;
  }

  .text {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-width: 0;
  }

  .title {
    font-size: 15.5px;
    font-weight: 500;
    overflow-wrap: anywhere;
  }

  .meta {
    font-size: 13px;
    color: #6b7280;
  }
</style>
